<template>
  <layout-with-back-btn title="Pengajuan Penarikan Barang">
    <div class="flex items-center justify-between gap-[10px] flex-wrap my-[24px]">
      <div class="d-flex rounded-lg align-items-center text-[#c2c2c2] px-[12px] py-[3px] border-[1px] border-[#e2e2e2] w-full sm:w-auto">
        <span
          class="k-search-normal-1 font-bold text-[24px] align-middle mx-[5px]"
        />
        <b-form-input
          v-model="mitraName"
          placeholder="Cari Nama Mitra"
          class="sm:!w-[250px] border-0 focus:!shadow-none !rounded-r-lg !text-[16px]"
          debounce="500"
        />
      </div>
      <div class="flex items-center gap-[8px] flex-wrap">
        <b-form-select
          v-model="statusType"
          :options="optionStatusType"
          value-field="value"
          text-field="text"
          placeholder="Order By"
          class="csw w-auto m-0 !border-[1px] !border-[#e2e2e2] !rounded-lg !text-[14px] !text-[#333333] !h-[40px]"
        />
        <date-picker
          v-model="period"
          input-label-class="!text-[14px] !font-[500] !text-[#c2c2c2]"
          :date-format="createDatePickerRestrictor()"
          :ranges="datePickerRangeGeneral"
        />
        <b-button
          variant="primary"
          class="!flex items-center justify-center gap-5 inline-block !text-[14px] !font-[600] !rounded-lg h-[41px] w-full sm:w-auto"
          :disbaled="loadingExportData"
          @click="exportData"
        >
          <b-spinner
            v-if="loadingExportData"
            small
          />
          Export Data
        </b-button>
      </div>
    </div>

    <b-overlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <b-table
        :items="items"
        :fields="fieldsRequestPackingTable"
        thead-class="font-[500] text-[#333333]"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        sticky-header="500px"
        class="text-[#333333]"
        @scroll.native="handleScrollTable"
      >
        <template #cell(no)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(submission_time)="data">
          <div>
            <span class="block font-[500]">{{ DAY_MONTH_YEAR(data.value) }}</span><span class="block text-[#626262]">{{ TIME(data.value) }}</span>
          </div>
        </template>
        <template #cell(status)="data">
          <span
            :class="[ statusPackingClass(data.value),
                      'font-[500] text-[12px] rounded-xl px-[12px] py-0.5']"
          >{{ data.value }}</span>
        </template>
        <template #cell(mitra_contact)="data">
          <div class="flex items-center gap-[4px]">
            <span class="k-Whatsapp text-[24px] text-[#10673E]" />
            <a
              :href="`https://wa.me/${data.value}`"
              target="_blank"
              class="text-[#10673E] underline hover:text-[#333333] hover:undeline transition"
            >{{ data.value }}</a>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
    </b-overlay>

  </layout-with-back-btn>
</template>

<script>
import {
  DAY_MONTH_YEAR, TIME, YEAR_MONTH_DAY, createDatePickerRestrictor,
} from '@/libs/filterDate'
import { today, last30 } from '@/store/helpers'
import { handleInfiniteScrollBTable } from '@/libs/scrollUtils'
import { downloadFileFromBlob } from '@/libs/downloadFile'
import LayoutWithBackBtn from '../../LayoutWithBackBtn.vue'
import DatePicker from '../../DatePicker.vue'
import { optionStatusType, fieldsRequestPackingTable } from './config'
import { datePickerRangeGeneral } from '../../config'

export default {
  components: {
    LayoutWithBackBtn,
    DatePicker,
  },
  data() {
    return {
      fieldsRequestPackingTable,
      optionStatusType,
      mitraName: '',
      statusType: 'all',
      period: {
        startDate: this.$route.query.start_date ? new Date(this.$route.query.start_date) : last30,
        endDate: this.$route.query.end_date ? new Date(this.$route.query.end_date) : today,
      },
      loadingExportData: false,
      items: [],
      loading: false,
      limit: 50,
      offset: 0,
      lastData: false,
    }
  },
  watch: {
    mitraName() {
      this.getListData()
    },
    period() {
      this.getListData()
    },
    statusType() {
      this.getListData()
    },
  },
  created() {
    this.datePickerRangeGeneral = datePickerRangeGeneral(today)
  },
  mounted() {
    this.getListData()
  },
  methods: {
    createDatePickerRestrictor,
    DAY_MONTH_YEAR,
    TIME,
    /**
     * Returns the CSS classes for styling the status packing badge based on type
     * @param {string} type - The status type ('Diajukan', 'Selesai', 'Ditolak', 'Diproses')
     * @returns {Object} Object containing CSS class mappings
     */
    statusPackingClass(type) {
      return {
        'bg-[#FFF2E2] text-[#FBA63C]': type === 'Diajukan',
        'bg-[#DCF3EB] text-[#34A770]': type === 'Selesai',
        'bg-[#FFEDED] text-[#E31A1A]': type === 'Ditolak',
        'bg-[#dff3ff] text-[#08A0F7]': type === 'Diproses',
      }
    },

    /**
     * Handles infinite scroll event for the table
     * @param {Event} event - The scroll event object
     */
    handleScrollTable(event) {
      handleInfiniteScrollBTable(event, !this.loading && !this.lastData, () => this.fetchData(false))
    },

    /**
     * Fetches data from the API with pagination support
     * @param {boolean} isNewSearch - Whether this is a new search that should reset pagination
     */
    async fetchData(isNewSearch = true) {
      if (this.loading) return

      this.loading = true
      if (isNewSearch) {
        this.offset = 0
        this.lastData = false
      }

      const url = '/komship/api/v1/admin/outbounds/trend-requests/withdrawal'

      try {
        const response = await this.$http_new.get(url, {
          params: {
            offset: this.offset,
            limit: this.limit,
            search: this.mitraName,
            filter: this.statusType,
            start_date: YEAR_MONTH_DAY(this.period.startDate),
            end_date: YEAR_MONTH_DAY(this.period.endDate),
          },
        })
        const { data } = response.data

        if (!data) {
          this.lastData = true
          if (isNewSearch) this.items = []
          return
        }

        if (isNewSearch) {
          this.items = data
        } else {
          this.items.push(...data)
        }

        this.offset += data.length
        this.lastData = data.length < this.limit
      } catch (err) {
        this.$toast_error({ message: 'Gagal mengambil data, silahkan coba lagi.' })
      } finally {
        this.loading = false
        if (this.isTabsLoading) {
          this.isTabsLoading = false
        }
      }
    },

    /**
     * Triggers a new data fetch with reset pagination
     */
    getListData() {
      this.fetchData(true)
    },

    /**
     * Exports the current data to an Excel file
     * Downloads file with date range in filename
     */
    exportData() {
      this.loadingExportData = true
      this.$http_new.post('/komship/api/v1/admin/outbounds/trend-requests/withdrawal/export-data', null, {
        params: {
          filter: this.statusType,
          search: this.mitraName,
          start_date: YEAR_MONTH_DAY(this.period.startDate),
          end_date: YEAR_MONTH_DAY(this.period.endDate),
        },
        responseType: 'blob',
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        downloadFileFromBlob(blob, `request_penarikan_barang_${DAY_MONTH_YEAR(this.period.startDate)} - ${DAY_MONTH_YEAR(this.period.endDate)}.xlsx`)
      }).catch(_err => {
        this.$toast_error({ message: 'Gagal mengunduh file, silahkan coba lagi.' })
      }).finally(() => {
        this.loadingExportData = false
      })
    },
  },
}
</script>
